//slots
import AR from "images/slots/AR.png";
import AR_slotted from "images/slots/AR_slotted.png";
import AT from "images/slots/AT.png";
import AT_slotted from "images/slots/AT_slotted.png";
import CO from "images/slots/CO.png";
import CO_slotted from "images/slots/CO_slotted.png";
import DEMO from "images/slots/DEMO.png";
import DEMO_slotted from "images/slots/DEMO_slotted.png";
import ENG from "images/slots/ENG.png";
import ENG_slotted from "images/slots/ENG_slotted.png";
import MAN from "images/slots/MAN.png";
import MAN_slotted from "images/slots/MAN_slotted.png";
import MED from "images/slots/MED.png";
import MED_slotted from "images/slots/MED_slotted.png";
import OFFICER from "images/slots/OFFICER.png";
import OFFICER_slotted from "images/slots/OFFICER_slotted.png";
import SL from "images/slots/SL.png";
import SL_slotted from "images/slots/SL_slotted.png";
import locked from "images/slots/locked.png";
import raffle from "images/slots/raffle.png";

//groups
//civ
import civ_blank from "images/groups/civ_blank.png";
import civ_humanitarian from "images/groups/civ_humanitarian.png";
import civ_med from "images/groups/civ_med.png";
import civ_press from "images/groups/civ_press.png";
import civ_spy from "images/groups/civ_spy.png";

//blue
import nato_aa from "images/groups/nato_aa.png";
import nato_aagun from "images/groups/nato_aagun.png";
import nato_aamissile from "images/groups/nato_aamissile.png";
import nato_armour from "images/groups/nato_armour.png";
import nato_art from "images/groups/nato_art.png";
import nato_at from "images/groups/nato_at.png";
import nato_eng from "images/groups/nato_eng.png";
import nato_fixedwing from "images/groups/nato_fixedwing.png";
import nato_inf from "images/groups/nato_inf.png";
import nato_infmech from "images/groups/nato_infmech.png";
import nato_med from "images/groups/nato_med.png";
import nato_mtr from "images/groups/nato_mtr.png";
import nato_naval from "images/groups/nato_naval.png";
import nato_para from "images/groups/nato_para.png";
import nato_rec from "images/groups/nato_rec.png";
import nato_rotary from "images/groups/nato_rotary.png";
import nato_sf from "images/groups/nato_sf.png";
import nato_sig from "images/groups/nato_sig.png";
import nato_supply from "images/groups/nato_supply.png";
import nato_uav from "images/groups/nato_uav.png";

//red
import opf_aa from "images/groups/opf_aa.png";
import opf_aagun from "images/groups/opf_aagun.png";
import opf_aamissile from "images/groups/opf_aamissile.png";
import opf_armour from "images/groups/opf_armour.png";
import opf_art from "images/groups/opf_art.png";
import opf_at from "images/groups/opf_at.png";
import opf_eng from "images/groups/opf_eng.png";
import opf_fixedwing from "images/groups/opf_fixedwing.png";
import opf_inf from "images/groups/opf_inf.png";
import opf_infmech from "images/groups/opf_infmech.png";
import opf_med from "images/groups/opf_med.png";
import opf_mtr from "images/groups/opf_mtr.png";
import opf_naval from "images/groups/opf_naval.png";
import opf_para from "images/groups/opf_para.png";
import opf_rec from "images/groups/opf_rec.png";
import opf_rotary from "images/groups/opf_rotary.png";
import opf_sf from "images/groups/opf_sf.png";
import opf_sig from "images/groups/opf_sig.png";
import opf_supply from "images/groups/opf_supply.png";
import opf_uav from "images/groups/opf_uav.png";

//ind
import ind_aa from "images/groups/ind_aa.png";
import ind_aagun from "images/groups/ind_aagun.png";
import ind_aamissile from "images/groups/ind_aamissile.png";
import ind_armour from "images/groups/ind_armour.png";
import ind_art from "images/groups/ind_art.png";
import ind_at from "images/groups/ind_at.png";
import ind_eng from "images/groups/ind_eng.png";
import ind_fixedwing from "images/groups/ind_fixedwing.png";
import ind_inf from "images/groups/ind_inf.png";
import ind_infmech from "images/groups/ind_infmech.png";
import ind_med from "images/groups/ind_med.png";
import ind_mtr from "images/groups/ind_mtr.png";
import ind_naval from "images/groups/ind_naval.png";
import ind_para from "images/groups/ind_para.png";
import ind_rec from "images/groups/ind_rec.png";
import ind_rotary from "images/groups/ind_rotary.png";
import ind_sf from "images/groups/ind_sf.png";
import ind_sig from "images/groups/ind_sig.png";
import ind_supply from "images/groups/ind_supply.png";
import ind_uav from "images/groups/ind_uav.png";

//misc images
import ErrorSymbol from "images/misc/Error.png";
import CaLogo from "images/misc/ca_full_no_background.png";
import CaLogoText from "images/misc/ca_logo_text.png";
import CaLogoTextHeader from "images/misc/ca_logo_text_header.png";
import TSLogo from "images/misc/TS_light_theme.png";
import DiscordLogo from "images/misc/discord.png";
import Arma3Units from "images/misc/Arma3Units.png";
import SteamGroup from "images/misc/steam_logo.png";
import Github from "images/misc/github.png";
import ArrowDown from "images/misc/arrow_down.png";
import mlady from "images/mlady.png";

//faq images

import actions from "images/faq/actions.png";
import briefing from "images/faq/briefing.png";
import hover from "images/faq/hover.png";
import reserves from "images/faq/reserves.png";
import slots from "images/faq/slots.png";
import summary from "images/faq/summary.png";
import slot_types from "images/faq/slot_types.png";

// eslint-disable-next-line
export default {
  AR,
  AR_slotted,
  AT,
  AT_slotted,
  CO,
  CO_slotted,
  DEMO,
  DEMO_slotted,
  ENG,
  ENG_slotted,
  MAN,
  MAN_slotted,
  MED,
  MED_slotted,
  OFFICER,
  OFFICER_slotted,
  SL,
  SL_slotted,
  locked,
  raffle,

  civ_blank,
  civ_humanitarian,
  civ_med,
  civ_press,
  civ_spy,

  ind_inf,
  ind_aa,
  ind_aagun,
  ind_aamissile,
  ind_armour,
  ind_art,
  ind_at,
  ind_eng,
  ind_fixedwing,
  ind_infmech,
  ind_med,
  ind_mtr,
  ind_naval,
  ind_para,
  ind_rec,
  ind_rotary,
  ind_sf,
  ind_sig,
  ind_supply,
  ind_uav,

  nato_inf,
  nato_aa,
  nato_aagun,
  nato_aamissile,
  nato_armour,
  nato_art,
  nato_at,
  nato_eng,
  nato_fixedwing,
  nato_infmech,
  nato_med,
  nato_mtr,
  nato_naval,
  nato_para,
  nato_rec,
  nato_rotary,
  nato_sf,
  nato_sig,
  nato_supply,
  nato_uav,

  opf_inf,
  opf_aa,
  opf_aagun,
  opf_aamissile,
  opf_armour,
  opf_art,
  opf_at,
  opf_eng,
  opf_fixedwing,
  opf_infmech,
  opf_med,
  opf_mtr,
  opf_naval,
  opf_para,
  opf_rec,
  opf_rotary,
  opf_sf,
  opf_sig,
  opf_supply,
  opf_uav,

  ErrorSymbol,
  CaLogo,
  CaLogoText,
  CaLogoTextHeader,
  TSLogo,
  DiscordLogo,
  Arma3Units,
  SteamGroup,
  Github,
  ArrowDown,
  mlady,

  actions,
  briefing,
  hover,
  reserves,
  slots,
  summary,
  slot_types,
};
